import { API } from "./api";

const VKEY = "cl_visitor_id";
const SKEY = "cl_session_id";

const uid = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

function visitorId() {
  let v = localStorage.getItem(VKEY);
  if (!v) { v = uid(); localStorage.setItem(VKEY, v); }
  return v;
}

function sessionId() {
  let s = sessionStorage.getItem(SKEY);
  if (!s) { s = uid(); sessionStorage.setItem(SKEY, s); }
  return s;
}

let firstEventSent = false;

export function track(event, props = {}) {
  try {
    const body = JSON.stringify({
      event,
      path: window.location.pathname,
      visitor_id: visitorId(),
      session_id: sessionId(),
      referrer: firstEventSent ? "" : (document.referrer || ""),
      ...props,
    });
    firstEventSent = true;
    const url = `${API}/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
  } catch (err) {
    /* analytics must never break the app */
    if (process.env.NODE_ENV === "development") console.debug("analytics send skipped", err);
  }
}
